"use client";

import { AlertCircle } from "lucide-react";
import { Button, EmptyState } from "@chotca/ui";
import { vi } from "@chotca/config";

export function ErrorState({
  title,
  description,
  onRetry,
}: {
  title?: string;
  description?: string;
  onRetry?: () => void;
}) {
  return (
    <EmptyState
      icon={<AlertCircle className="h-7 w-7 text-ember" />}
      title={title ?? vi.common.errorTitle}
      description={description ?? vi.common.errorBody}
      action={
        onRetry ? (
          <Button size="sm" variant="ghost" onClick={onRetry}>
            {vi.common.retry}
          </Button>
        ) : undefined
      }
    />
  );
}
